import { render, staticRenderFns } from "./OutlinedCardContent.vue?vue&type=template&id=2cfd3fe7"
import script from "./OutlinedCardContent.vue?vue&type=script&lang=js"
export * from "./OutlinedCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports